module.exports = __webpack_public_path__ + "img/m115.3680a85a.jpg";